<mat-select
  placeholder="Select a state"
  [value]="value"
  [disabled]="disabled"
  (selectionChange)="handleChange($event.value)">
  @for (state of states; track state) {
    <mat-option [value]="state.abbreviation">
      {{state.name}} ({{state.abbreviation}})
    </mat-option>
  }
</mat-select>
